export default Object.freeze({
   none: 'none',
   video: 'video',
   videoPlaylist: 'videoPlaylist'
});
